import { tokens } from 'ComponentLibrary/style-dictionary/output'
import { Autocomplete, Box, Popper, TextField } from '@mui/material'
import { Control, useFieldArray } from 'react-hook-form'
import { UploadFileFormType } from 'ComponentLibrary/src/molecules/FileUploadModal/types'
import { DocumentTagOption, tagOptions as defaultTagOptions } from './constants'
import { ContentChip } from 'ComponentLibrary/src/piazza/content'
import { CaretDown } from 'ComponentLibrary/src/atoms/Select/Select'

type SelectTagsProps = {
    control: Control<UploadFileFormType>
    index: number
    label?: string
    options?: DocumentTagOption[]
    disabled?: boolean
}

export const SelectTags = ({ control, index, label = 'Tags', options = defaultTagOptions, disabled }: SelectTagsProps) => {
    const { fields: selectedTags, replace } = useFieldArray({
        control,
        name: `documents.${index}.tags`,
    })

    return (
        <Autocomplete<DocumentTagOption, true, false, false>
            size="medium"
            popupIcon={<CaretDown />}
            fullWidth
            disabled={disabled}
            renderInput={(params) => {
                return <TextField {...params} label={label} />
            }}
            options={options.filter((tag) => !selectedTags.some((selectedTag) => selectedTag.title === tag.title))}
            value={selectedTags}
            onChange={(_, tags) => {
                replace(tags)
            }}
            getOptionLabel={(option) => option.title || ''}
            renderOption={(listAttributes, tag) => (
                <li {...listAttributes} key={tag.title}>
                    <ContentChip size="small" label={tag.title} color={tag.color} />
                </li>
            )}
            multiple
            PopperComponent={(props) => <Popper {...props} sx={{ ...props.sx, zIndex: '1600 !important' }} />}
            renderTags={(selectedTags) =>
                selectedTags.map((tag) => (
                    <Box
                        key={tag.title}
                        marginRight={tokens.SizingSpacing075}
                        marginBottom={tokens.SizingSpacing025}
                        marginTop={tokens.SizingSpacing025}
                    >
                        <ContentChip label={tag.title} color={tag.color} size="small" />
                    </Box>
                ))
            }
            disableCloseOnSelect
        />
    )
}
